import React, {Fragment } from 'react';
import Tabs from 'react-responsive-tabs';
import Templates from "../../Templates";
import QuickReply from "../../QuickReply";
import QuickReplyForm from '../../QuickReply/QuickReplyForm';

const tabsContent = [
    {
        title: 'Message Templates',
        content: <Templates />
    },
    {
        title: 'Quick Reply',
        content: <QuickReplyForm />
    }
];

function getTabs() {
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

class TemplateSettings extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            selectedTab : 0 ,
            defaultSelectedTab : props.defaultSelectedTab,
            tabInfo : {'messagetemplates' : 0, 'quickreply' : 1}
        }
    }
    
    componentDidMount = () => {
        if( this.state.defaultSelectedTab !== undefined && this.state.tabInfo[this.state.defaultSelectedTab] !== undefined){
            this.setState({
                selectedTab : this.state.tabInfo[this.state.defaultSelectedTab]
            });
        }
    }
    render() {
        return (
            <Fragment>
                <Tabs 
                    tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding" 
                    selectedTabKey={this.state.selectedTab}
                    transform={false} 
                    showInkBar={true} 
                    items={getTabs()}
                />
            </Fragment>
        )
    }

}

export default TemplateSettings;
